import { api } from "@/lib/api";

const fromB64 = (s) => {
  s = String(s).replace(/-/g, "+").replace(/_/g, "/");
  while (s.length % 4) s += "=";
  const bin = atob(s);
  return Uint8Array.from(bin, (c) => c.charCodeAt(0)).buffer;
};
const toB64 = (buf) => {
  const bytes = new Uint8Array(buf);
  let s = "";
  for (const b of bytes) s += String.fromCharCode(b);
  return btoa(s).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

export const webauthnSupported = () => !!(window.PublicKeyCredential && navigator.credentials?.create);

// Whether the device has a usable Face ID / Touch ID / fingerprint (platform authenticator).
export async function biometricAvailable() {
  if (!webauthnSupported()) return false;
  try {
    return await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
  } catch {
    return false;
  }
}

export async function registerBiometric() {
  const o = await api.bioRegOptions();
  o.challenge = fromB64(o.challenge);
  o.user.id = fromB64(o.user.id);
  (o.excludeCredentials || []).forEach((x) => (x.id = fromB64(x.id)));
  const c = await navigator.credentials.create({ publicKey: o });
  return api.bioRegVerify({
    id: c.id,
    rawId: toB64(c.rawId),
    type: c.type,
    response: {
      clientDataJSON: toB64(c.response.clientDataJSON),
      attestationObject: toB64(c.response.attestationObject),
    },
  });
}

export async function unlockBiometric(signal) {
  const o = await api.bioAuthOptions();
  o.challenge = fromB64(o.challenge);
  (o.allowCredentials || []).forEach((x) => (x.id = fromB64(x.id)));
  const c = await navigator.credentials.get({ publicKey: o, signal });
  return api.bioAuthVerify({
    id: c.id,
    rawId: toB64(c.rawId),
    type: c.type,
    response: {
      clientDataJSON: toB64(c.response.clientDataJSON),
      authenticatorData: toB64(c.response.authenticatorData),
      signature: toB64(c.response.signature),
      userHandle: c.response.userHandle ? toB64(c.response.userHandle) : null,
    },
  });
}
